import React from 'react'

import ContactItem from '../container/ContactItem'
import AddressItem from '../container/AddressItem'

const Contact = () => {
  return (
    <div>

        
        <ContactItem/>
        <AddressItem/>
     
    </div>
  )
}

export default Contact